import { User, BAFTA_USERNAME } from "@ecologi/shared";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import useMedia from "react-use/lib/useMedia";
import { ForestWrapper, Wrapper } from "./OmniForestComponents";
import { AlbertModal } from "./components/AlbertModal";
import { ForestTitleBox } from "./components/ForestTitleBox";
import { GrassTuftsBackground } from "./components/GrassTuftsBackground";

export type OmniForestProps = {
  children: React.ReactNode;
  isOwnProfile: boolean;
  onCreatePaymentLink: (payload: any) => Promise<void>;
  onDeactivatePaymentLink: (payload: any) => Promise<void>;
  onEditTitle: (payload: any) => Promise<any>;
  profile: User;
  user: User | null;
  isNewBaftaExperienceEnabled?: boolean;
};

export const OmniForest = ({
  children,
  isOwnProfile,
  onCreatePaymentLink,
  onDeactivatePaymentLink,
  onEditTitle,
  profile,
  user,
  isNewBaftaExperienceEnabled,
}: OmniForestProps) => {
  const router = useRouter();
  const mobileUp = useMedia("(min-width: 480px)", true);
  const { albertsuccess, session_id } = router.query;

  const isForestHidden = profile.username === BAFTA_USERNAME;

  const [isAlbertModalOpen, setAlbertModalState] = useState(false);
  const [isAlbertConfirmationModalOpen, setalbertConfirmationModal] =
    useState<boolean>(false);

  useEffect(() => {
    albertsuccess === "true" ? setalbertConfirmationModal(true) : null;

    if (albertsuccess === "true" && session_id) {
      const sessionId = session_id;
      const userId = profile.userId;
      onDeactivatePaymentLink({ sessionId, userId });

      router.replace(`/${profile.username}`, undefined, {
        shallow: true,
      });
    }
  }, [session_id]);

  return (
    <div>
      <div id="forest">
        <ForestWrapper>
          <Wrapper
            data-testid="profile-forest-section"
            isForestHidden={isForestHidden}
          >
            {!isForestHidden && (
              <>
                <ForestTitleBox
                  onEditTitle={onEditTitle}
                  user={user}
                  isNewBaftaExperienceEnabled={isNewBaftaExperienceEnabled}
                  {...{
                    profile,
                    isOwnProfile,
                    setAlbertModalState,
                  }}
                />

                {children}
                {mobileUp && <GrassTuftsBackground />}
              </>
            )}
          </Wrapper>
        </ForestWrapper>
      </div>

      {(isAlbertModalOpen || isAlbertConfirmationModalOpen) && (
        <AlbertModal
          close={() => {
            // Make sure there isn't any params in the route
            router.replace(`/${profile.username}`, undefined, {
              shallow: true,
            });
            setAlbertModalState(false);
            setalbertConfirmationModal(false);
          }}
          setAlbertModalState={setAlbertModalState}
          setalbertConfirmationModal={setalbertConfirmationModal}
          isAlbertModalOpen={isAlbertModalOpen}
          isAlbertConfirmationModalOpen={isAlbertConfirmationModalOpen}
          profile={profile}
          createPaymentLink={async (data: any) => {
            return onCreatePaymentLink(data);
          }}
        />
      )}
    </div>
  );
};
